// src/providers/ToastProvider.tsx
// ═══════════════════════════════════════════════════════════════════════════════
// REACT-TOASTIFY PROVIDER
// ═══════════════════════════════════════════════════════════════════════════════

import React from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastProviderProps {
  children: React.ReactNode;
}

/**
 * Toast Provider with React-Toastify
 */
export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
        limit={5}
        toastStyle={{
          borderRadius: "8px",
          padding: "12px 16px",
        }}
      />
    </>
  );
};
